/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsPortfolio extends models.AppSecopsPortfolioBase {
    getFixupPrototypeFunction() { return AppSecopsPortfolio.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsPortfolio>): AppSecopsPortfolio {
        let obj = Object.assign(new AppSecopsPortfolio(), model);
        AppSecopsPortfolio.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsPortfolio>): AppSecopsPortfolio {
        if (!model) return null;
        return AppSecopsPortfolio.newInstance(<AppSecopsPortfolio> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsPortfolio) {
        if (!obj) return;

        models.AppSecopsPortfolio.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsPortfolio): boolean {
        if (models.AppSecopsPortfolioBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsPortfolio.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Portfolio created time
     */
    created_at: Date;

    /**
     * Name of the user who created the portfolio
     */
    created_by: string;

    /**
     * Portfolio ID
     */
    portfolio_id: string;

    /**
     * Name of the user who recently updated the portfolio
     */
    updated_by: string;

    /**
     * Portfolio updated time
     */
    updated_at: Date;

}
